import styled from 'styled-components';

const OFFSET_INTENSITY = 0.66;

export const NotificationWrapperContainerElement = styled.div`
    position: relative;
    display: flex;
`;

export interface NotificationContainerElementProps {
    size: number;
}

export const NotificationContainerElement = styled.div<NotificationContainerElementProps>`
    position: absolute;
    left: calc(100% - ${(props) => props.size * OFFSET_INTENSITY}px);
    bottom: calc(100% - ${(props) => props.size * OFFSET_INTENSITY}px);

    display: flex;
    justify-content: center;
    align-items: center;
`;
